import { SearchEntity } from '@finance-lab/utils/types'

export const getUrlForType = (option: Pick<SearchEntity, 'entityType' | 'id'>) => {
    if (option.entityType === 'Issue') {
        return `/issues/${option.id}`
    } else if (option.entityType === 'Warrant') {
        return `/warrants/${option.id}`
    } else if (option.entityType === 'Company') {
        return `/companies/${option.id}`
    } else if (option.entityType === 'Investor') {
        return `/investors/${option.id}`
    } else if (option.entityType === 'Convertible') {
        return `/convertibles/${option.id}`
    }
}
